"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCtaAssetLinkProperty = exports.ctaAssetLinkPropertyDefinition = void 0;
exports.ctaAssetLinkPropertyDefinition = {
    view: { label: 'Asset' },
    constraints: [
        {
            name: 'stencils',
            argument: [
                'artist',
                'athlete',
                'episode-video',
                'event-profile',
                'event-series',
                'external-content-resource',
                'film',
                'project-profile',
                'recap-video',
                'show',
                'story',
                'trailer-video',
                'video',
                'video-vr-360',
            ],
        },
        {
            name: 'required',
            argument: true,
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'cta-asset-link',
};
const isCtaAssetLinkProperty = (prop) => {
    return prop.name === exports.ctaAssetLinkPropertyDefinition.name;
};
exports.isCtaAssetLinkProperty = isCtaAssetLinkProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3RhLWFzc2V0LWxpbmsucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9jdGEtYXNzZXQtbGluay5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLDhCQUE4QixHQUFHO0lBQzVDLElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxPQUFPLEVBQUU7SUFDeEIsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUU7Z0JBQ1IsUUFBUTtnQkFDUixTQUFTO2dCQUNULGVBQWU7Z0JBQ2YsZUFBZTtnQkFDZixjQUFjO2dCQUNkLDJCQUEyQjtnQkFDM0IsTUFBTTtnQkFDTixpQkFBaUI7Z0JBQ2pCLGFBQWE7Z0JBQ2IsTUFBTTtnQkFDTixPQUFPO2dCQUNQLGVBQWU7Z0JBQ2YsT0FBTztnQkFDUCxjQUFjO2FBQ2Y7U0FDRjtRQUNEO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLElBQUk7U0FDZjtLQUNGO0lBQ0QsSUFBSSxFQUFFLE9BQU87SUFDYixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxnQkFBZ0I7Q0FDUyxDQUFBO0FBSTFCLE1BQU0sc0JBQXNCLEdBQUcsQ0FBQyxJQUFrQixFQUFnQyxFQUFFO0lBQ3pGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxzQ0FBOEIsQ0FBQyxJQUFJLENBQUE7QUFDMUQsQ0FBQyxDQUFBO0FBRlksUUFBQSxzQkFBc0IsMEJBRWxDIn0=